import React from 'react';
import { Table } from 'react-bootstrap';

// Renderiza a hierarquia de centros de custo com indent visual por nível.
// indent vem do backend: '' | '....' | '.........' | '................'
const TabelaIndentada = ({ dados }) => {
  if (!dados || dados.length === 0) {
    return (
      <div className="text-center text-muted py-4">
        Nenhum centro de custo encontrado.
      </div>
    );
  }

  return (
    <Table striped bordered hover size="sm" className="mt-3">
      <thead>
        <tr>
          <th>Código</th>
          <th>Descrição</th>
          <th>Categoria</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        {dados.map((row) => (
          <tr key={`cc-${row.codigo}-${row.nivel}`}>
            <td>{row.codigo}</td>
            <td>
              {row.indent}
              {row.descricao}
            </td>
            <td>{row.categoria}</td>
            <td>{row.status}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default TabelaIndentada;
